import { Page } from 'components/Page';
import { PageEmpty } from 'components/PageEmpty';
import { theme } from 'lib/theme';
import * as React from 'react';
import { NavigationHeader } from 'components/NavigationHeader';
import { ViewWithSeparators } from 'components/ViewWithSeparators';
import { View } from 'react-native';
import { selectIsSidebarVisible } from 'store/remote/selectors';
import { useSelector } from 'hooks/useSelector';
import { Txt } from 'components/Txt';
import { SidebarShowButton } from '../../../../componentsAware/SidebarShowButton';

export const PageUnknown: React.FC = () => {
  const isSidebarVisible = useSelector(selectIsSidebarVisible);
  return (
    <Page
      isInModal={false}
      contentPaddingTop={0}
      ignoreSafeAreaBottom
      header={
        <NavigationHeader marginLeft={0}>
          <View style={{ marginRight: theme.paddingHorizontalHalf }}>
            {!isSidebarVisible && <SidebarShowButton />}
          </View>
          <ViewWithSeparators
            horizontal
            style={{
              alignItems: 'center',
              flex: 1,
            }}
            separatorMargin={theme.paddingHorizontalHalf}
            separatorColor="transparent"
          >
            <Txt weight="bold" numberOfLines={1}>
              Unknown Page
            </Txt>
          </ViewWithSeparators>
        </NavigationHeader>
      }
    >
      <PageEmpty
        // text="Page Empty"
        subtext="This page does not exist"
        iconCircled={false}
        style={{ backgroundColor: theme.colors.background }}
      />
    </Page>
  );
};
